import * as api from 'services/api';
import apiPaths from 'services/apiPaths';
import { ResourceTypeDetailEnum, ResourceTypeEnum } from 'src/shared/enums';
import {
  ComboData,
  IChallenge,
  IChallengeCheckout,
  IChallengeResource,
} from 'src/shared/models';
const NO_STOCK = '0';
export const getExperienceResourceClassName = (
  challengeResources: IChallengeResource[],
  i: number,
  type: ResourceTypeEnum,
) => {
  const isComponentWrapper = (type) => {
    return [
      ResourceTypeEnum.EXPERIENCE_ACTIVATION,
      ResourceTypeEnum.INCLUDED_ITEMS_LIST,
      ResourceTypeEnum.QUIZ_TYPEFORM,
      ResourceTypeEnum.QUIZ,
      ResourceTypeEnum.REDEEM_PRODUCT,
      ResourceTypeEnum.STEPS,
      ResourceTypeEnum.TEXT,
      ResourceTypeEnum.TEXT_DURATION,
      ResourceTypeEnum.TEXT_LINK,
      ResourceTypeEnum.VIDEO,
      ResourceTypeEnum.VIDEO_SECTION,
      ResourceTypeEnum.WYSIWYG,
      ResourceTypeEnum.HIDDEN,
      ResourceTypeEnum.CHECKOUT_BOOKING_TIMIFY,
      ResourceTypeEnum.CHECKOUT_PAYMENT_GATEWAY,
    ].includes(type);
  };
  const isWrapper = isComponentWrapper(type);

  if (!isWrapper) return '';

  if (isWrapper && i === challengeResources.length - 1)
    return ' experience-module-last';

  if (isWrapper && i < challengeResources.length - 1) {
    const isNextItemWrapper = isComponentWrapper(
      challengeResources[i + 1].type,
    );
    if (!isNextItemWrapper) return 'experience-module experience-module-last';
  }

  return 'experience-module';
};

export const checkExperienceStock = ({ resourceList }: IChallenge): boolean => {
  const productResources = resourceList.filter(
    ({ idResourceType: { idResourceType }, status: resourceStatus }) =>
      idResourceType === ResourceTypeEnum.CHECKOUT_PRODUCT && resourceStatus,
  );

  if (!productResources?.length) {
    return false;
  }

  const outOfStock = productResources.every(
    ({ resourceDetailList }) =>
      resourceDetailList[
        resourceDetailList.findIndex(
          ({ idResourceTypeD }) =>
            idResourceTypeD.idResourceTypeD ===
            ResourceTypeDetailEnum.CHECKOUT_PRODUCT_CURRENT_STOCK,
        )
      ].value === NO_STOCK,
  );

  return outOfStock;
};

export const getRegions = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.REGION_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getDepartments = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.DEPARTMENT_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getProvinces = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.PROVINCE_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getDistricts = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.DISTRICT_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getSuburbs = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.SUBURB_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getCLComunas = async () => {
  try {
    const response = await api.getApiCombo(apiPaths.COMBO_IDS.COMUNA_LIST);
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getUserAddressList = async () => {
  try {
    const response = await api.getDataCall({
      dataPath: apiPaths.PROFILE.USER_ADDRESS,
    });
    return response?.data ?? [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getRegionName = (regionList: ComboData[], region: string) => {
  if (!region || !regionList?.length) return '';
  return regionList.find((reg) => reg.value === region)?.description || '';
};

export const getCheckoutDoneMessage = (
  challengeResources: IChallengeResource[],
): string | null => {
  const checkout = challengeResources.find(
    ({ type }) => type === ResourceTypeEnum.CHECKOUT,
  );
  if (!checkout) return '';

  const config: IChallengeCheckout = checkout.config;
  return config?.completedLabel || '';
};

export const getTaxCountry = async () => {
  try {
    const response = await api.getDataCall({
      dataPath: apiPaths.CALL.COUNTRY_TAX,
    });

    return response?.data ?? 0;
  } catch (err) {
    console.error(err);
    return 0;
  }
};
